import React, { useState } from 'react';
import Select from 'react-select';
import { Field } from 'react-final-form';
import { InputLabel } from '@mui/material';

export const donationFrequencyOptions = [
  {
    label: 'Regular',
    value: 'regular',
  },
  {
    label: 'Seasonal',
    value: 'seasonal',
  },
  {
    label: 'Occasional',
    value: 'occasional',
  },
  {
    label: 'One-time',
    value: 'one-time',
  },
];

const DonationFrequencySelect = ({ value }) => {
  const [selectedFrequency, setSelectedFrequency] = useState(
    value ? donationFrequencyOptions.find((frequency) => frequency.value === value) : null
  );

  return (
    <>
      <InputLabel shrink>Donation Frequency</InputLabel>

      <Field
        name="frequency"
        render={({ input }) => (
          <Select
            fullWidth
            name="frequency"
            placeholder="Select Donation Frequency"
            onChange={(option) => {
              input.onChange(option !== null ? option.value : null);

              setSelectedFrequency(option);
            }}
            value={selectedFrequency}
            options={donationFrequencyOptions}
          />
        )}
      />
    </>
  );
};

export default DonationFrequencySelect;
